import { z } from 'zod';
import { toEmptyString } from './preprocess';

const ONLY_LETTERS = /^[A-Za-zÀ-ÿ\s]+$/;
const PASCAL_CASE = /^[A-ZÀ-Ý][a-zà-ÿ]+$/;
const CONNECTORS = new Set(['de', 'da', 'do', 'dos', 'das', 'e']);

const hasMinTwoWords = (name: string) => name.trim().split(/\s+/).length >= 2;

const isPascalCase = (name: string) =>
  /^[A-ZÀ-Ý][a-zà-ÿ]+(?:\s[A-ZÀ-Ý][a-zà-ÿ]+)+$/.test(name.trim());

const isPascalCaseWithConnectors = (name: string) =>
  name.split(' ').every(word => {
    if (CONNECTORS.has(word.toLowerCase())) return true;
    return PASCAL_CASE.test(word);
  });

/** Nome — signUp e quiz (sem preprocess, sem conectores). */
export const nameField = z
  .string()
  .min(1, 'Nome completo é obrigatório')
  .regex(ONLY_LETTERS, 'Use apenas letras')
  .refine(hasMinTwoWords, 'Informe nome e sobrenome')
  .refine(isPascalCase, 'Use Pascal Case (ex: Ana Luisa)');

/** Nome — nationalUserSchema (com preprocess, aceita conectores). */
export const fullName = z.preprocess(
  toEmptyString,
  z
    .string()
    .trim()
    .min(1, 'Nome completo é obrigatório')
    .regex(ONLY_LETTERS, 'Use apenas letras')
    .refine(hasMinTwoWords, 'Informe nome e sobrenome')
    .refine(
      isPascalCaseWithConnectors,
      'Use formatação correta (ex: Ana de Souza)'
    )
);
